import { Box, Button, IconButton, Tooltip } from '@mui/material'
import { MdEdit } from 'react-icons/md'
import { useFormikContext } from 'formik'
import { metodoPrograma } from '../../../../components/api'
import { setError, setSuccess } from '../../../../components/alerts'
import { useModal } from '../../../../components/Utils/UseModal'
import { useCheckin } from './CheckinContext'
import CardTable from '../../../../components/CardTable'
import ModalDescontoProposta from '../ModalDescontoProposta'

const PropostaCard = ({ preencherAltura }) => {
  const { values, setFieldValue } = useFormikContext()
  const { idAtendimento, podeAplicarDesconto } = useCheckin()
  const modalDesconto = useModal(ModalDescontoProposta)

  const saldoOriginal = (values.vlSubTotal || 0) - (values.vlCaucao || 0)
  const saldoProposta = saldoOriginal - (values.vlDescontoCheckin || 0)
  const temDesconto = Number(values.vlDescontoCheckin || 0) > 0

  const itens = [
    { label: 'SubTotal', valor: values.vlSubTotal || 0 },
    { label: 'Caução', valor: values.vlCaucao || 0 },
    ...(temDesconto
      ? [
          {
            label: 'Desconto na Proposta',
            valor: values.vlDescontoCheckin,
          },
        ]
      : []),
  ]

  const aplicarDesconto = async () => {
    const desconto = await modalDesconto({
      saldoProposta: saldoOriginal,
      vlDescontoCheckin: values.vlDescontoCheckin,
    })
    if (!desconto) return

    if (!values.idPedidoVenda) {
      setFieldValue(
        'vlDescontoCheckin',
        Number(desconto.vlDescontoCheckin || 0),
      )
      return setSuccess('Desconto será aplicado ao salvar o check-in')
    }

    const resposta = await metodoPrograma(
      'aplicaDescontoProposta',
      { idAtendimento, ...desconto },
      'CtrlOrcamentoCheckin',
    )
    if (!resposta.status)
      return setError(resposta.dsErro || 'Não foi possível aplicar o desconto')

    setFieldValue('vlDescontoCheckin', Number(resposta.vlDescontoCheckin || 0))
    setFieldValue('vlTotal', Number(resposta.vlTotal || 0))
    setSuccess('Desconto aplicado na proposta')
  }

  return (
    <CardTable
      titulo={`Proposta #${idAtendimento || ''}`}
      dadosTabela={itens}
      colunas={['Descrição', 'Valor']}
      mapear={(item) => [item.label, item.valor]}
      colunasMoeda={[1]}
      opcoesColuna={
        temDesconto && podeAplicarDesconto
          ? [
              {
                alias: 1,
                customJsx: ({ itemFormatado, linhaOriginal }) =>
                  linhaOriginal.label === 'Desconto na Proposta' ? (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        width: '100%',
                      }}
                    >
                      <Tooltip title="Editar desconto na proposta">
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={aplicarDesconto}
                          sx={{ mr: 0.5, p: 0.25 }}
                        >
                          <MdEdit size={16} />
                        </IconButton>
                      </Tooltip>
                      <Box component="span">{itemFormatado}</Box>
                    </Box>
                  ) : (
                    itemFormatado
                  ),
              },
            ]
          : []
      }
      preencherAltura={preencherAltura}
      estiloColunas={[{ width: '60%' }, { width: '40%', textAlign: 'right' }]}
      rotuloTotal="Saldo Proposta"
      valorTotal={saldoProposta}
      semBordas
      acaoTitulo={
        podeAplicarDesconto && saldoProposta > 0 && !temDesconto ? (
          <Button
            color="primary"
            variant="contained"
            size="small"
            onClick={aplicarDesconto}
            sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
          >
            Aplicar Desconto na Proposta
          </Button>
        ) : null
      }
    />
  )
}

export default PropostaCard
